import {
  UseQueryOptions,
  UseQueryResult,
  useQuery,
} from '@tanstack/react-query';
import { IFHError } from '../../../../apis/HttpBaseApiWrapper';
import { TPaginationParams } from '../../../../apis/__shared/shared.interfaces';
import { useUsersService } from '../../../../apis/users/useUsersService';
import { TParentListApiResponse } from '../../../../apis/users/users.interfaces';

type TQueryError = IFHError<{ message: string }>;
export const getParentListKey = 'get-parents-list';

export const useParentListHook = (
  params: TPaginationParams,
  options?: UseQueryOptions<TParentListApiResponse, TQueryError>
): UseQueryResult<TParentListApiResponse, TQueryError> => {
  const { getParentList } = useUsersService();

  const queryKey = [getParentListKey, params];

  return useQuery<TParentListApiResponse, TQueryError>({
    queryKey,
    queryFn: () => getParentList(params),
    enabled: true,
    ...options,
  });
};
